import { t, type I18nKey } from '@/lib/i18n';

// Xbox store category (EN) → i18n genre key. Unmapped categories fall back to raw.
const CATEGORY_KEY: Record<string, I18nKey> = {
  'Action & adventure': 'genre_action',
  'Shooter':            'genre_shooter',
  'Role playing':       'genre_rpg',
  'Racing & flying':    'genre_racing',
  'Sports':             'genre_sports',
  'Fighting':           'genre_fighting',
  'Simulation':         'genre_simulation',
  'Strategy':           'genre_strategy',
  'Puzzle & trivia':    'genre_puzzle',
  'Platformer':         'genre_platformer',
  'Family & kids':      'genre_family',
  'Music':              'genre_music',
};

/** Localized genre/category label for cards, meta rows, etc. */
export function genreLabel(category: string | null | undefined, lang: string | null | undefined): string {
  if (!category) return '';
  const key = CATEGORY_KEY[category];
  return key ? (t(key, lang) || category) : category;
}
